<template>
  <div class="register-container"></div>
</template>
<script>
export default {
  name: 'Register',
  props: [],
  components: {},
  data() {
    return {

    }
  },
  created() {},
  methods: {},
  mounted() {
    console.log(this.$http)
  }
}

</script>
<style scoped>
.register-container {
  width: 100%;
  height: auto;
}

</style>
